import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import { makeRPCPost } from '~api/RpcAPI/RpcAPI';

import { IPGResponse } from '~api/CartAPI/ICartApiSdk';

const googleAIDefaults = {
    useNGGlobal: true,
    placementId: 'recently_viewed_default',
    pageSize: 8,
    dryRun: 'false',
    eventType: 'home-page-view',
    filter: '',
    productId: ''
};

export const fetchRecommendedItems = () => {
    const { config } = diContainer.get(serviceNames.config);
    const {
        useNGGlobal,
        placementId,
        pageSize,
        dryRun,
        eventType,
        googleFilter: filter,
        productIdTag: productId
    } = config?.cartConfig?.recommendedConfigs || googleAIDefaults;
    const googleAIRecommendConfigs = {
        useNGGlobal,
        placementId,
        pageSize,
        dryRun: dryRun.toString(),
        eventType,
        filter,
        productId
    };

    const body = [
        {
            method: 'user.googleAIRecommend',
            params: [googleAIRecommendConfigs]
        }
    ];

    return makeRPCPost<typeof googleAIRecommendConfigs, IPGResponse<string>>(body);
};
